// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/motion-sickness.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/motion-sickness/motion-sickness.js';

mount([g0]);
